module.exports = __webpack_public_path__ + "assets/chrome-c13b8289439042e06b686166778e7b7c.svg";